import React from 'react'
import { compose, pure } from 'recompose'
// import styles from './navButtonComponent.scss'
import PropTypes from 'prop-types'

export function NavButton (props) {
  if (props.display) {
    return (
      <button
        type='button'
        className={props.className}
        onClick={props.onClick}
        aria-label={props.ariaLabel}
      >
        {props.children}
      </button>
    )
  } else {
    return false
  }
}
NavButton.propTypes = {
  children: PropTypes.any,
  onClick: PropTypes.func,
  className: PropTypes.string,
  display: PropTypes.bool,
  ariaLabel: PropTypes.string.isRequired
}
NavButton.defaultProps = {
  display: true
}

export default compose(pure)(NavButton)



// WEBPACK FOOTER //
// ./src/components/navButton/navButtonComponent.js